//import React,
import {useState,useEffect} from "react";
import TableWrapper from './TableWrapper';
import { useSelector, useDispatch } from "react-redux";
import {
    selectors as SearchResultSelector,
    operations as searchResultOperations,
  } from "../../../redux/SearchResult";

  //20240316 jag added id throughout
const TableWrapperContainer = ({ id, name, json, index, chartRef, chartWidth }) => {

    const [loader, setLoader] = useState(true);
    const [theadData, setTheadData] = useState([]);
    const [tbodyData, setTbodyData] = useState([]);
    const [message, setMessage] = useState("");
    const [outputDetails, setOutputDetails] = useState({}); 
    const [barChartDetails, setBarChartDetails] = useState([]);
    const [barChartValues, setBarChartValues] = useState([]);
    
    const dispatch = useDispatch();
    const searchData = searchResultOperations.dispatchLoadSearchData(dispatch);
    const dispatchBarChartDetails = searchResultOperations.dispatchBarChartDetails(dispatch);
    const dispatchBarChartValues = searchResultOperations.dispatchBarChartValues(dispatch);

    const { tableData } = useSelector((state) => ({
      tableData: SearchResultSelector.loadData(state)
    }));

    useEffect(()=> {
      dispatchBarChartDetails(barChartDetails);
    },[barChartDetails]);

    useEffect(()=> {
      dispatchBarChartValues(barChartValues);
    },[barChartValues]);
  
    useEffect(() => {
      //20240316 jag added id used in saga:loadSearchData
      console.log("TableWrapperContainer::useEffect() ID: ", id);
      if (id && name && json) {
        const obj = {
          id,
          name,
          json,
        };
        searchData(obj);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name, json, index]);
  
    useEffect(() => {
      console.log("TableWrapperContainer::useEffect() ID: ", id);
      if (tableData[name]) {
        let thead = [];
        let tbody = [];
        let tableBodyArr = tableData[name]?.results ?? [];
        let metadata = tableData[name]?.metadata ?? [];
        let barChartDetails = tableData[name]?.output?.chart ?? {};
        let localOutputDetails = {
          score: tableData[name]?.output?.score,
          sources: tableData[name]?.output?.sources,
          locationip: tableData[name]?.output?.locationip,
        };
        let barChartValues = [];  //stores values to be charted
        setOutputDetails(localOutputDetails);
  
        //collect the header names (the order is critical)
         if (metadata?.length) {
          setMessage("");
          metadata?.forEach((header, mainHeaderIndex) => {
            thead.push(header.name);
          });
        }
 
        setMessage("");  
        if (tableBodyArr?.length) {
          console.log("TableWrapperContainer::useEffect() ID: ", id, "Processing", tableData[name]?.output?.sources);
          console.log("TableWrapperContainer::useEffect() ID: ", id, "Processing Header", thead);
          //iterate the results row
          tableBodyArr?.forEach((row, mainRowIndex) => {
            let rowArray = [];
            let chartObj = {};
            //console.log("TableWrapperContainer::useEffect() Processing Row: ", row);
            if (thead?.length) {
              //iterate the headers sorting the columns
              thead?.forEach((column, mainColumnIndex) => {
                //console.log("TableWrapperContainer::useEffect() Processing Column: ", column);
                if (row.hasOwnProperty(column)) {
                  //add the column value, to our results array for the row
                  rowArray.push(row[column]);
                }

                //check for a chart, if so save the info
                if (barChartDetails?.xaxis === column) {
                  chartObj[column] = row[column];
                }
                if (barChartDetails?.yaxis === column) {
                  chartObj[column] = row[column];
                }
              });
              //add the row values to tbody
              tbody.push(rowArray);

              //save the chart info, only the first 10 rows
              if (Object.keys(chartObj)?.length) {
                if(mainRowIndex <=9) {
                  //limit chart item to the first 10
                  barChartValues.push(chartObj);
                }
              }
            }
          });
          setBarChartDetails(barChartDetails);
          setBarChartValues(barChartValues);
          setTheadData(thead);
          setTbodyData(tbody);
          setLoader(false);
          
          console.log("TableWrapperContainer::useEffect() ID: ". id, "Processed", tableData[name]?.output?.sources);
          
        } else {
          setMessage("TableWrapperContainer::useEffect() ID: ", id, "No Data Found", tableData[name]?.output?.sources);
          console.log("TableWrapperContainer::useEffect() ID: ", id, "No Data Found", tableData[name]?.output?.sources);
          setLoader(true);
        }
  
        //setTheadData(thead);
        //setTbodyData(tbody);
       // setLoader(true);
      } else {
        setMessage("TableWrapperContainer::useEffect() ID: ", id, "tableData[name] is null", name);
        console.log("TableWrapperContainer::useEffect() ID: ", id, "tableData[name] is null", name);
        setLoader(true);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData[name]]);

  return <TableWrapper
    loader={loader}
    theadData={theadData}
    tbodyData={tbodyData}
    message={message}
    outputDetails={outputDetails}
    barChartDetails={barChartDetails}
    barChartValues={barChartValues}
    chartRef={chartRef}
    chartWidth={chartWidth}
    />;
};

export default TableWrapperContainer;
